import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { QuoteMediaEodPriceTasksTable } from '../../../../../../../../../../features/vendor/quotemedia/eod-price/task/quotemedia-eod-price-tasks-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorQuoteMedia,
      label: 'Tasks',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorQuoteMedia>,
  head: () => getPageHead('QuoteMedia EOD Price Tasks'),
  component: QuoteMediaEodPriceTasksList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingVendorQuoteMedia}
    />
  );
}

function QuoteMediaEodPriceTasksList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <QuoteMediaEodPriceTasksTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
